import { Component } from '@angular/core'
import { FormBuilder } from '@angular/forms'
import { Store } from '@ngrx/store'
import { DataCheckerService } from '@tokeet-frontend/tv3-platform'
import { SignaturePreferenceGuard } from '@tokeet-frontend/signature'
import { DocumentsPrefForm } from './documents-pref-form'

@Component({
  selector: 'app-documents-pref-form',
  templateUrl: './documents-pref-form.component.html',
  styles: [],
})
export class DocumentsPrefFormComponent extends DocumentsPrefForm {
  constructor(protected fb: FormBuilder, protected store: Store<any>, private dataChecker: DataCheckerService) {
    super(fb, store)
    this.dataChecker.check([SignaturePreferenceGuard])
  }
}
